import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { specials } from '../data/specials';

/** Homepage preview of the current promotions; full details live on /specials. */
export function SpecialsStrip() {
  return <section className="w-full py-14 px-4 bg-black" aria-labelledby="specials-strip-heading" data-id="element-564" data-mp="2676hhoy964rk">
      <div className="max-w-7xl mx-auto border-4 rounded-2xl p-5 sm:p-8 lg:p-10" style={{
      borderColor: '#FFE81A',
      backgroundColor: '#0b0b0b'
    }} data-id="element-565" data-mp="218vbjpb2weem">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8" data-id="element-566" data-mp="2b7b1vq2a7jn2">
          <div data-id="element-567" data-mp="2p00re4h0r6ox">
            <p className="text-sm font-black uppercase tracking-widest text-red-500" data-id="element-568" data-mp="2oyfvobiyxhph">
              Limited Time Only
            </p>
            <h2 id="specials-strip-heading" className="mt-1 text-3xl sm:text-4xl md:text-5xl font-black uppercase text-white" data-id="element-569" data-mp="2k30i7kovhntl">
              Current <span className="text-yellow-400" style={{
              color: "#FFE81A"
            }} data-id="element-570" data-mp="2tzdjb3mqz3yd">Specials</span>
            </h2>
          </div>
          <Link to="/specials" className="inline-flex items-center gap-2 text-yellow-400 font-black uppercase tracking-wider hover:text-yellow-300 transition-colors duration-150" style={{
          color: "#FFE81A"
        }} data-id="element-571" data-mp="1n1awmg1586ys">
            View all specials
            <ArrowRight className="w-4 h-4" aria-hidden="true" data-id="element-572" data-mp="1w30mvijagzuz" />
          </Link>
        </div>

        <ul className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-zinc-800 border border-zinc-800 rounded-xl overflow-hidden" data-id="element-573" data-mp="20xebn23g48qo">
          {specials.map(special => <li key={special.service} className="bg-black" data-id="element-574" data-mp="2awwu1e3pjmgm">
              <Link to={special.path} className="flex flex-col h-full p-5 sm:p-6 hover:bg-zinc-900 transition-colors duration-150" data-id="element-575" data-mp="2fon7hsxxyqc9">
                <span className="text-4xl sm:text-5xl font-black text-yellow-400 leading-none" style={{
              color: "#FFE81A"
            }} data-id="element-576" data-mp="2jqibx6b65ju9">
                  {special.amount}
                  <span className="ml-1 text-xl sm:text-2xl" data-id="element-577" data-mp="2tofv3fe68qg0">OFF</span>
                </span>
                <span className="mt-3 text-base sm:text-lg font-black uppercase text-white" data-id="element-578" data-mp="2tm3f37rz4q5l">
                  {special.service}
                </span>
                {special.condition && <span className="mt-1 text-xs sm:text-sm text-gray-400" data-id="element-579" data-mp="oowz6m322udz">
                    {special.condition}
                  </span>}
              </Link>
            </li>)}
        </ul>
      </div>
    </section>;
}